import TemplateSelector from './TemplateSelector';
import {connect} from '../../app/connect';
import {
  getActiveTemplates,
  getRecentlyUsedTemplates,
  getTemplateCategories,
  getUncategorizedTemplateCategoryId
} from '../../app/templates/template-selectors';

const mapStateToProps = state => ({
  templateCategories: getTemplateCategories(state),
  activeTemplates: getActiveTemplates(state),
  recentlyUsedTemplates: getRecentlyUsedTemplates(state),
  uncategorizedCategoryId: getUncategorizedTemplateCategoryId(state)
});

export default connect(mapStateToProps)(TemplateSelector);
